import { Component, Input } from '@angular/core';
import { AbstractAppAuthentication } from '../../app-services/authentication/authentication.app.abstract';
import { AppMonitoring } from '../../app-services/monitoring/monitor.app';
import { FormsConfig } from '../../app.config.forms';
import { MaterialDesignConfig } from '../../app.config.material';

@Component({
    selector: 'app-system-info',
    imports: [
        ...FormsConfig,
        ...MaterialDesignConfig
    ],
    templateUrl: './system-info.component.html',
    styleUrl: './system-info.component.scss'
})
export class SystemInfoComponent {

  @Input({required: true}) displaySystemInfo = false;
  
  public get userId() : string | undefined {
    return this.serviceAuth.account?.localAccountId
  }
  
  public get userName() : string | undefined {
    return this.serviceAuth.account?.name
  }
  
  public get applicationInsightsId() : string | undefined {
    return this.serviceMonitoring.appInsights.config.instrumentationKey?.toString();
  }  

  constructor(private serviceAuth: AbstractAppAuthentication, private serviceMonitoring: AppMonitoring) {  }
}
